import { CultureInfo } from '../culture-info.model';
import { CultureInfoDe } from './de';

/**
 * @ignore
 */
export const CultureInfoDeLI: CultureInfo = {
  name: 'de-LI',
  displayName: 'German (Liechtenstein)',
  iso3LanguageCode: 'deu',
  iso2LanguageCode: 'de',
  ietfLanguageTag: 'de-LI',
  parent: CultureInfoDe
};
